
import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import CustomerGateway from '~apis/customer';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { TGetCustomerConversionReduxParams } from '~types/feat/customer';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetCustomerConversionListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerConversionListingAttempt', handleGetCustomerConversionListing, api);
}

function* handleGetCustomerConversionListing(api: CustomerGateway, data: PayloadAction<TGetCustomerConversionReduxParams>) {
    const reduxState = store.getState();

    const authToken = reduxState.auth.userDetails.authToken;
    const index = reduxState.customer.customerConversion.index;

    const { id } = data.payload;

    if (!id || (index !== 0 && !index)) {
        yield put(combinedActions.customerGetCustomerConversionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getCustomerConversionListing],
        {
            authToken,
            index,
            id,
        }
    );

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerConversionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerConversionListingSuccess(response.data));
    }
}
